import { createApp } from 'vue'
import { createI18n } from 'vue-i18n'
import App from './App.vue'
import router from './router'
import './assets/scss/tailwind.scss'
import './assets/css/materialdesignicons.min.css'
import pl from "./locales/pl.json" 
import en from "./locales/en.json" 
import de from "./locales/de.json" 

const i18n = createI18n({ 
    locale: navigator.language, 
    fallbackLocale: "en", 
    messages: { pl, en, de }, 
    legacy: false 
  })

  const app = createApp(App) 
  app.use(router)
  app.use(i18n)
  app.mount('#app')

